export default __webpack_public_path__ + "static/media/unleash.b8e17118.svg";